module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/chat-smile-7d2a802a3f13867ac53cd2b638cb1b39.svg";